{
  "favourites": {
    "contactForm": {
      "contactAdvertiser": "Anbieter kontaktieren"
    },
    "note": {
      "buttons": {
        "deleteNote": "Notiz löschen",
        "editNote": "Notiz bearbeiten",
        "writeNote": "Notiz hinzufügen"
      },
      "deleteModal": {
        "cancel": "Nein",
        "delete": "Ja",
        "message": "Möchtest du deine Notiz löschen?",
        "title": "Deine Notiz löschen"
      },
      "editModal": {
        "cancel": "Abbrechen",
        "placeholder": "Add a note",
        "save": "Anwenden",
        "title": "Bearbeite deine Notiz"
      },
      "title": "Deine Notiz"
    },
    "page": {
      "crossDevice": {
        "loggedin": {
          "message": "Deine Favoriten und Notizen sind jetzt auf all deinen Geräten verfügbar.",
          "title": "Du bist angemeldet"
        },
        "login": {
          "button": "Anmelden",
          "message": "Melde dich an, um deine Favoriten und Notizen auf all deinen Geräten zu synchronisieren (Handy, Laptop, etc.).",
          "title": "Deine Favoriten, überall dabei"
        }
      },
      "explanation": "Behalte den Überblick über deine Lieblingsinserate, indem du auf das Herzsymbol klickst.",
      "favouriteRemoved": "Favorit entfernt",
      "heading": "Favoriten",
      "headline": "Deine Favoriten an einem Ort",
      "noLongerAvailableMessage": "Ein Favorit ist nicht mehr verfügbar. | {count} Favoriten sind nicht mehr verfügbar.",
      "propertyOwnership": {
        "accountSettingsLink": "Kontoeinstellungen",
        "confirmationMessage": "Das hilft uns, dir relevantere Inhalte anzuzeigen. Du kannst das jederzeit in den ",
        "confirmationTitle": "Danke für deine Antwort!",
        "description": "Wir nutzen diese Information, um zu verstehen, welche Funktionen rund ums Eigenheim für dich relevant sein könnten.",
        "no": "Nein, ich besitze keine Immobilie",
        "title": "Besitzt du aktuell eine Immobilie?",
        "yes": "Ja, ich besitze eine Immobilie",
        "howCtaBadge": "Du besitzt eine Immobilie",
        "howCtaHeadline": "Sieh dir den geschätzten Wert und das Mietpotenzial deiner Immobilie an",
        "howCtaBody": {
          "emphasis": "Eigentümerportal",
          "mainText": "Füge deine Immobilie in etwa 2 Minuten zu {emphasis} hinzu. Du kannst sie jederzeit bearbeiten oder entfernen."
        },
        "howCtaPrimary": "Immobilie hinzufügen",
        "howCtaLearnMore": "Mehr erfahren"
      },
      "onboardingMessage": {
        "message": "Deine Favoriten werden nur auf diesem Gerät gespeichert.",
        "title": "Hinweis"
      },
      "title": {
        "hg": "Favoriten | homegate.ch",
        "is24": "Favoriten | ImmoScout24"
      },
      "undo": "Rückgängig machen"
    },
    "remove": "Entfernen",
    "save": "Speichern"
  }
}